export default __webpack_public_path__ + "static/media/geers.5d2b68fa.jpg";